import React, { memo } from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Text, View } from '../Base';
import ParcelIcon from '../icons/Parcel';
import { PARCEL_SEARCH } from '../../constants/strings';
import palette from '../styles/palette';

const useStyles = makeStyles(({ typography }) => ({
  button: {
    color: palette.typography.white.solid,
    textTransform: 'capitalize',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '&:hover': {
      background: 'transparent',
    },
  },
  text: {
    color: palette.typography.white.solid,
    fontSize: typography.pxToRem(12),
    fontWeight: 400,
  },
  icon: {
    maxWidth: typography.pxToRem(15),
    maxHeight: typography.pxToRem(16),

    '& svg': {
      width: typography.pxToRem(15),
      height: typography.pxToRem(16),
      fill: palette.typography.white.solid,
    },
  },
}));

const SearchParcel = ({ onParcelSearch }) => {
  const classes = useStyles();

  return (
    <Button
      disableRipple
      onClick={onParcelSearch}
      className={classes.button}
      endIcon={
        <View className={classes.icon}>
          <ParcelIcon />
        </View>
      }
      data-testid="parcel-search"
    >
      <Text className={classes.text}>{PARCEL_SEARCH}</Text>
    </Button>
  );
};

export default memo(SearchParcel);
